import { render, staticRenderFns } from "./VolunteerActualPets.vue?vue&type=template&id=1aa4702c&scoped=true&"
import script from "./VolunteerActualPets.vue?vue&type=script&lang=js&"
export * from "./VolunteerActualPets.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerActualPets.vue?vue&type=style&index=0&id=1aa4702c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4702c",
  null
  
)

export default component.exports